import {call, put, takeLatest} from "redux-saga/effects";
import {API} from "../../../api/api";
import {ConfigurationsActionTypes} from "../actions/actionTypes";
import {configurationsAPI} from "../api/api";
import {ToasterService} from "../../../services/toaster/toaster.service";
import _ from "lodash";

function* getDecibels(action) {
    try {
        // Get Decibels Info
        const decibels = yield call(() => configurationsAPI.getDecibels());

        yield put({
            type: ConfigurationsActionTypes.GET_DECIBELS_SUCCESS,
            payload: decibels.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Decibels Information");

        yield put({
            type: ConfigurationsActionTypes.GET_DECIBELS_FAIL,
            payload: e
        });
    }
}

export function* getDecibelsWatcher() {
    yield takeLatest(ConfigurationsActionTypes.GET_DECIBELS, getDecibels);
}

function* getPercentages(action) {
    try {
        // Get Percentages Info
        const percentages = yield call(() =>
            configurationsAPI.getPercentages()
        );

        yield put({
            type: ConfigurationsActionTypes.GET_PERCENTAGE_SUCCESS,
            payload: percentages.data
        });
    } catch (e) {
        API.handleError(
            e.response,
            "Error getting Sound Percentages Information"
        );

        yield put({
            type: ConfigurationsActionTypes.GET_PERCENTAGE_FAIL,
            payload: e
        });
    }
}

export function* getPercentagesWatcher() {
    yield takeLatest(ConfigurationsActionTypes.GET_PERCENTAGE, getPercentages);
}

function* getSoundServer(action) {
    try {
        const {subsidiary, serverId, version} = action.payload;
        const gameInstances = yield call(() =>
            configurationsAPI.getGameInstances({subsidiary})
        );

        const uniqueGameInstances: any[] = _.uniqBy(
            gameInstances.data["results"],
            gameConfiguration => gameConfiguration.game.id
        );
        const gameInstancesParsed = {
            results: uniqueGameInstances.map(gc => {
                return {
                    id: gc.game.id,
                    game: {...gc.game, name: gc.label},
                    subsidiary: gc.subsidiary,
                    identifier: gc.game.id,
                    description: gc.label,
                    type: gc.game.type,
                    image: gc.image
                };
            })
        };

        yield put({
            type: ConfigurationsActionTypes.GET_GAME_INSTANCES_SUCCESS,
            payload: gameInstancesParsed
        });

        try {
            const soundGroups = yield call(() =>
                configurationsAPI.getSoundGroups()
            );

            yield put({
                type: ConfigurationsActionTypes.GET_SOUNDS_GROUPS_SUCCESS,
                payload: soundGroups.data
            });

            let sounds = [];
            for (let i = 0; i < soundGroups.data.results.length; i++) {
                // CREATE GROUPS FOR GAME INSTANCE
                let tempGroup = soundGroups.data.results[i];
                delete tempGroup.game_type_events;

                let groupedGameInstances = gameInstancesParsed.results.map(
                    gameInstance => {
                        // FOR EACH GAME INSTANCE
                        // WAVE-1039 jogo do tipo lotto o default do level = normal (gameInstance.type == 2)
                        return {
                            ...gameInstance,
                            ...soundGroups.data.results[i],
                            level: gameInstance.type == 2 ? 3 : tempGroup.id == 2 || tempGroup.id == 3
                                ? 1
                                : 2,
                            sub_level: soundGroups.data.results[i].sub_level_enabled
                                ? 2
                                : null,
                            originalLevel: gameInstance.type == 2 ? 3 : tempGroup.id == 2 || tempGroup.id == 3
                                ? 1
                                : 2,
                            originalSubLevel: soundGroups.data.results[i].sub_level_enabled
                                ? 2
                                : null
                        };
                    }
                );
                sounds = sounds.concat(groupedGameInstances);
            }

            try {
                // GET SETTINGS SOUND FOR SERVER
                if (version !== null) {
                    const soundsServer = yield call(() =>
                        configurationsAPI.getSoundServer({serverId, version})
                    );

                    soundsServer.data.map(soundSetting => {
                        soundSetting.groups.map(group => {
                            let matchIndex = _.findIndex(sounds, {
                                id: group.id,
                                identifier: soundSetting.identifier
                            });

                            sounds[matchIndex] = {
                                ...sounds[matchIndex],
                                level: group.level,
                                sub_level: sounds[matchIndex].sub_level_enabled
                                    ? group.sub_level
                                    : null,
                                originalLevel: group.level,
                                originalSubLevel: sounds[matchIndex]
                                    .sub_level_enabled
                                    ? group.sub_level
                                    : null
                            };
                        });
                    });
                }

                // SEND SOUNDS
                yield put({
                    type: ConfigurationsActionTypes.GET_SOUNDS_SUCCESS,
                    payload: _.orderBy(sounds, ["description"], ["asc"])
                });

                yield put({
                    type: ConfigurationsActionTypes.REORDER_SOUNDS_SUCCESS,
                    payload: {key: "description", direction: "asc"}
                });
            } catch (e) {
                // SEND SOUNDS
                yield put({
                    type: ConfigurationsActionTypes.GET_SOUNDS_SUCCESS,
                    payload: _.orderBy(sounds, ["description"], ["asc"])
                });

                yield put({
                    type: ConfigurationsActionTypes.REORDER_SOUNDS_SUCCESS,
                    payload: {key: "description", direction: "asc"}
                });

                API.handleError(e.response);

                yield put({
                    type: ConfigurationsActionTypes.GET_SOUNDS_SERVER_FAIL,
                    payload: e
                });
            }
        } catch (e) {
            API.handleError(e.response, "Error getting Sounds Groups");

            yield put({
                type: ConfigurationsActionTypes.GET_SOUNDS_GROUPS_FAIL,
                payload: e
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error fetching game instances.");

        yield put({
            type: ConfigurationsActionTypes.GET_GAME_INSTANCES_FAIL,
            payload: e
        });
    }
}

export function* getSoundServerWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_SOUNDS_SERVER,
        getSoundServer
    );
}

function* reorderSounds(action) {
    const {sounds, order} = action.payload;

    try {
        let reordered = _.orderBy(sounds, order.key, order.direction);
        yield put({
            type: ConfigurationsActionTypes.GET_SOUNDS_SUCCESS,
            payload: reordered
        });

        yield put({
            type: ConfigurationsActionTypes.REORDER_SOUNDS_SUCCESS,
            payload: order
        });
    } catch (e) {
        ToasterService.errorToast("Unable to reorder sounds settings.");
    }
}

export function* reorderSoundsWatcher() {
    yield takeLatest(ConfigurationsActionTypes.REORDER_SOUNDS, reorderSounds);
}
